import React from 'react';
import { observer } from 'mobx-react';

import { Button } from 'semantic-ui-react';

import '../css/ClassroomContentLauncherButton.less';

import { SatCoreRegister } from '../SatCoreRegistry';

import CourseService from '../services/CourseService';

const ClassroomContentLauncherButton = observer((props) => {
  const { history, t } = props;

  const handleClick = async () => {
    // Default behavior: redirect to Library
    await CourseService.redirectAddCourseButtonToLibrary(history);

    // note: we can potentially extend this method (as needed) to perform other
    // functionalities, such as opening the AddCourseToClassModal via
    // `dialogManager.setOpenDialog(DIALOG_NAMES.ADD_COURSE_TO_CLASS, {...})`, etc.)
  };

  const buttonLabel = t('classroomContentLauncherButtonLabel');

  return (
    <div className='ClassroomContentLauncherButton'>
      <div className='classroom-content-launcher-btn-wrapper'>
        <Button aria-label={buttonLabel} onClick={handleClick}>
          {buttonLabel}
        </Button>
      </div>
    </div>
  );
});

export default ClassroomContentLauncherButton;
SatCoreRegister('ClassroomContentLauncherButton', ClassroomContentLauncherButton);
